import { errorSlice } from '../ErrorSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('error', errorSlice)

export const useErrorSlice = (): ReturnType<typeof useGetMethodsAndData> => useGetMethodsAndData()

export default useErrorSlice
